import React, { useEffect, useState, useMemo } from "react";
import baseService from "services/BaseService";
import DynamicForm from "../../../pages/Ordering/common/DynamicForm";
import Loader from "components/Loader";
import { GET_MAX_FILE_SIZE_FROM_DICT } from 'constants/index';


const PersonalData = props => {
    const { partiesId, t } = props;

    const [personalData, setPersonalData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const liveSaveUrlKey = "save_user_profile_modal_dyn_param";

    const maxFileSize = useMemo(() => GET_MAX_FILE_SIZE_FROM_DICT("form"), []);

    const requestPersonalData = () => {
        setIsLoading(true);
        const params = {
            data: {
                objectType: "PARTY@SPEC",
                objectTypeCode: "USER",
                openMode: "update",
                ctxObjectType: "PARTY",
                curStepNum: 1,
                ctxObjectId: partiesId,
            },
        };
        baseService.get("dinamic_params", params).then(({ success, result }) => {
            setIsLoading(false);
            if (success) {
                if (result && result.blocks) {
                    setPersonalData(result.blocks);
                }
            } else {
                console.log("Request user modal personal data failed.");
            }
        });
    };

    useEffect(() => {
        requestPersonalData();
    }, []);

    return (
        <>
            {isLoading && <Loader />}

            {personalData && (
                <DynamicForm
                    formName={"user-profile-modal-form"}
                    dynData={personalData}
                    t={t}
                    liveSave
                    liveSaveUrlKey={liveSaveUrlKey}
                    liveSaveJSON
                    currentId={parseInt(partiesId, 10)}
                    liveSaveIdKey="id"
                    maxFileSize={maxFileSize}
                />
            )}
        </>
    );
};

export default PersonalData;
